import React, { useEffect, useRef, useState } from "react";
import { Box, styled } from "@mui/system";
import { IconButton, useMediaQuery } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import cardOrListTheme from "../../../../assets/cardOrListTheme";
import useResponsiveScaling from "../../../../utils/useResponsiveScaling";

const theme = cardOrListTheme;

const FramePage = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const frameRef = useRef(null);
  const handleScroll = () => {
    if (frameRef.current) {
      if (frameRef.current.scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  };
  const scrollToTop = () => {
    if (frameRef.current) {
      frameRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    const container = frameRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  const paddingTop = `${20 + 64}px`;
  const wrapperPadding = `${paddingTop} 20px 20px 20px`;
  const backgroundColor = "#EEEEEE";

  return (
    <Background ref={frameRef} style={{ overflowY: "auto", backgroundColor }}>
      <Box
        style={{
          padding: wrapperPadding,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          height: "100%",
          transition: "padding 0.25s ease-out",
        }}
      >
        {props.children}
      </Box>
      <BackToTopButton
        onClick={scrollToTop}
        style={{
          display: isVisible ? "block" : "none",
        }}
      />
    </Background>
  );
};
const Background = styled("div")({
  margin: 0,
  padding: 0,
  width: "100%",
  height: "100%",
});

const BackToTopButton = ({ onClick, style }) => (
  <IconButton
    title='Go to top'
    onClick={onClick}
    style={{
      position: "fixed",
      bottom: "20px",
      right: "30px",
      zIndex: 99,
      border: "none",
      outline: "none",
      backgroundColor: "#555",
      color: "white",
      cursor: "pointer",
      padding: "10px",
      borderRadius: "50%",
      fontSize: "10px",
      ":hover": {
        backgroundColor: "#777",
        transition: 1,
      },
      ...style,
    }}
  >
    <KeyboardArrowUpIcon />
  </IconButton>
);

export default FramePage;
